import './index.scss';
import { useEffect, FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Typography } from '@material-ui/core';
import { SubmissionContent } from './SubmissionContent';
import { FiltersContainer } from './Filters';
import { Controllers } from './Controllers';
import { SubmissionsList } from './SubmissionsList';
import { translate } from '@utils';
import { makeEmployeeNumber } from '@actions/submissionEnvironmentActions';
import { submissionsSelector } from '@selectors/submission';

const LettersPage: FC = () => {
  const dispatch = useDispatch();
  const submissions = useSelector(submissionsSelector);

  useEffect(() => {
    dispatch(makeEmployeeNumber());
  }, []);

  return (
    <div className="letters-page-container">
      <div className="letters-block">
        <FiltersContainer />
        <SubmissionsList />
      </div>
      <div className="dividing-line" />
      <div className="main-block">
        <div className="control-block">
          <Controllers />
        </div>
        {submissions.length ? (
          <SubmissionContent />
        ) : (
          <div className="main-content">
            <div className="template-container" id="renderer">
              <Typography className="main-block__message main-block__message-template" variant="h2">
                {translate('no_template')}
              </Typography>
            </div>
            <div className="dividing-line" />
            <div className="form-wrapper">
              <Typography className=" main-block__message main-block__message-form">
                {translate('no_form')}
              </Typography>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export { LettersPage };
